import layout from '@/components/layout/layout'

const notFound = {
  path: '*',
  name: 'notFound',
  redirect: '/notFound',
  component: layout,
  children: [
    {
      path: '',
      redirect: '',
      component: () => import('@/views/notFound/notFound')
    }
  ]
}

export default notFound
